import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type {
  ChangePasswordInputDto,
  CreditUsageItemDto,
  MeOutputDto,
} from './model';

export const queryMe = queryOptions({
  queryKey: ['我是谁'],
  queryFn: () => {
    return http.get('user').json<MeOutputDto>();
  },
  initialData: {
    id: '',
    name: 'anonymous',
    permissions: [],
    is_admin: false,
    is_department_admin: false,
    department_users: [],
  },
});

export const changePasswordMutation = mutationOptions({
  mutationFn: (data: ChangePasswordInputDto) => {
    return http.put('user/password', { json: data });
  },
});

export const queryUserUsage = queryOptions({
  queryKey: ['信用点用量'],
  queryFn: () => {
    return http.get('user/usage').json<CreditUsageItemDto>();
  },
});
